(() => {
  const config = document.currentScript?.dataset ?? {};
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (select instanceof HTMLSelectElement && select.hasAttribute('data-hs-autosubmit')) select.form?.submit();
  });

  if (!customElements.get('hs-back-to-top')) {
    customElements.define(
      'hs-back-to-top',
      class extends HTMLElement {
        connectedCallback() {
          this.threshold = Number(this.dataset.threshold) || 200;
          this.querySelector('button').addEventListener('click', () =>
            window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' })
          );
          this.onScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              const max = document.documentElement.scrollHeight - window.innerHeight;
              this.toggleAttribute('data-visible', window.scrollY > this.threshold);
              this.style.setProperty('--hs-scroll-progress', String(max > 0 ? Math.min(window.scrollY / max, 1) : 0));
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
        }
      }
    );
  }

  const wrapHeaderMenu = () => {
    const list = document.querySelector('header-menu overflow-list');
    const inner = list?.shadowRoot?.querySelector('[part="list"]');
    if (!list || !inner || !window.matchMedia('(min-width: 990px)').matches) return;
    if (inner.style.overflow !== 'unset') {
      requestAnimationFrame(wrapHeaderMenu);
      return;
    }
    list.setAttribute('disabled', 'true');
    list.classList.add('hs-menu-wrap');
  };
  if (config.wrapMenu === 'true') wrapHeaderMenu();

  const bounceInterval = Number(config.cartBounce) * 1000;
  if (bounceInterval && !reducedMotion.matches) {
    setInterval(() => {
      const bubble = document.querySelector('.header-actions__cart-icon .cart-bubble:not(.visually-hidden)');
      if (!bubble || document.hidden) return;
      bubble.classList.remove('hs-bounce');
      void bubble.offsetWidth;
      bubble.classList.add('hs-bounce');
    }, bounceInterval);
  }

  if (
    config.reveal === 'true' &&
    !reducedMotion.matches &&
    !window.Shopify?.designMode &&
    'IntersectionObserver' in window
  ) {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('hs-reveal--in');
          observer.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    for (const section of document.querySelectorAll('main > .shopify-section')) {
      if (section.getBoundingClientRect().top <= window.innerHeight) continue;
      section.classList.add('hs-reveal');
      observer.observe(section);
    }
  }

  // Card swatch rows measured before fonts/images settle can collapse to "+N" with no swatches visible.
  const reflowSwatches = () => {
    for (const list of document.querySelectorAll('product-card overflow-list')) {
      list.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
    }
  };
  window.addEventListener('load', reflowSwatches);
  window.addEventListener('pageshow', (event) => event.persisted && reflowSwatches());
  document.fonts?.ready.then(reflowSwatches);
})();
